module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_features_08-dede01df0543372e5d168e9d0f9e2cd2.png";